import { Capacitor } from '@capacitor/core';

/**
 * Every platform branch in the app funnels through this module, so what is
 * native and what is not is decided in one place.
 */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** iOS and Android differ enough that some flows need to know which. */
export function platformName(): 'ios' | 'android' | 'web' {
  const p = Capacitor.getPlatform();
  return p === 'ios' || p === 'android' ? p : 'web';
}

/**
 * The web build talks to a dev proxy at /api; a phone has no proxy, so the
 * native build needs a real address.
 */
export const API_BASE_URL = isNativePlatform()
  ? (import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api')
  : '/api';
